import { useEffect, useState } from 'react'

import { reportsApi } from '@/api/reports.api'

import { useDebounce } from './useDebounce'

export const useExpenses = (search: string, enabled = true) => {
  const [data, setData] = useState<string[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<any>(null)

  const debouncedSearch = useDebounce(search, 300)

  useEffect(() => {
    if (!enabled) return

    const fetchExpenses = async () => {
      setIsLoading(true)
      try {
        const response = await reportsApi.getExpenses({
          name: debouncedSearch,
          limit: 100
        })
        setData(response.Expenses ?? [])
        setError(null)
      } catch (err) {
        setError(err)
      } finally {
        setIsLoading(false)
      }
    }

    fetchExpenses()
  }, [debouncedSearch, enabled])

  return { data, isLoading, error }
}
